import './bootstrap';
import { createApp } from 'vue';
import { MaskInput } from 'vue-3-mask';
import { VueTheMask } from 'vue-the-mask';
import store from './store';
window.__store__ = store;

const app = createApp({
    mounted() {
        // this.getFavourites();
        // this.getFavouritesCount();

        this.$store.dispatch('checkAuth');
        this.$store.dispatch('cart/getCart');
    }
});

app.use(store);

app.use(require('vue-cookies'))
app.$cookies.config('30d')

app.component('MaskInput', MaskInput);
app.use(VueTheMask)

// import ExampleComponent from './components/ExampleComponent.vue';
// app.component('example-component', ExampleComponent);
import Favourites from './components/Favourites.vue';
import FavouritesAddButton from './components/FavouritesAddButton.vue';
import FavouritesAddBigButton from './components/FavouritesAddBigButton.vue';
import Cart from './components/Cart.vue';
import CartHeader from './components/CartHeader.vue';
import CartCalculation from './components/CartCalculation.vue';
import CartItems from './components/CartItems.vue';
import CartItem from './components/CartItem.vue';
import CartItemSizes from "./components/CartItemSizes.vue";
import CartDelivery from './components/CartDelivery.vue';
import CartOrder from './components/CartOrder.vue';
import CartAddButtonWithCounter from './components/CartAddButtonWithCounter.vue';
import CartAddBigButton from './components/CartAddBigButton.vue';
import CartAddButton from './components/CartAddButton.vue';
import ProductGallery from './components/ProductGallery.vue';
import LastEvents from './components/LastEvents.vue';
import CatalogCategory from './components/CatalogCategory.vue';
import CatalogItemsGrid from './components/CatalogItemsGrid.vue';
import Callback from './components/Callback.vue';
import AddedToCartToast from './components/AddedToCartToast.vue';
import AddedToFavouritesToast from './components/AddedToFavouritesToast.vue';
// import CartItemSizes from './components/CartItemSizes.vue';

app.component('favourites', Favourites);
app.component('favourites-add-button', FavouritesAddButton);
app.component('favourites-add-big-button', FavouritesAddBigButton);
app.component('cart', Cart);
app.component('cart-header', CartHeader);
app.component('cart-calculation', CartCalculation);
app.component('cart-items', CartItems);
app.component('cart-item', CartItem);
app.component('cart-item-sizes', CartItemSizes);
app.component('cart-delivery', CartDelivery);
app.component('cart-order', CartOrder);
app.component('cart-add-button-with-counter', CartAddButtonWithCounter);
app.component('cart-add-big-button', CartAddBigButton);
app.component('cart-add-button', CartAddButton);
app.component('product-gallery', ProductGallery);
app.component('last-events', LastEvents);
app.component('catalog-category', CatalogCategory);
app.component('catalog-items-grid', CatalogItemsGrid);
app.component('callback', Callback);
app.component('added-to-cart-toast', AddedToCartToast);
app.component('added-to-cart-favourites', AddedToFavouritesToast);

app.mount('#app');

console.log('it works!');
